module.exports = __webpack_public_path__ + "media/images/minimize-square-minus-d785812c4b75836c16bb1862bfccfcaf.png";